// eslint-disable-next-line no-restricted-imports
import cookies from 'js-cookie'
import type { LanguagesArray, PreferredLanguageDTO, PreferredLanguageResponse } from './entities'
import { getConfig } from '@/tools/config'
import { fetcher } from '@/tools/fetcher/client'
import type { Language } from '@/tools/i18n'
import { preferredLanguageCookieName } from '@/tools/i18n/constants'

export const fetchPreferredLanguages = async (
  options: PreferredLanguageDTO
): Promise<PreferredLanguageResponse> => {
  const { apiUrl } = getConfig()
  const response = await fetcher.get(
    `${apiUrl}/customer_profile/api/v1/language_management/supported_languages`,
    {
      data: options.data,
    }
  )
  return response.data
}

export const setPreferredLanguage = async (languageCode: string): Promise<void> => {
  const { apiUrl } = getConfig()
  await fetcher.put(`${apiUrl}/customer_profile/api/v1/language_management/preferred_language`, {
    preferredLanguage: languageCode,
  })
  cookies.set(preferredLanguageCookieName, languageCode)
}

export const getPreferredLanguage = async (): Promise<Language> => {
  const { apiUrl } = getConfig()

  const preferredLanguageInCookie = cookies.get(preferredLanguageCookieName) as Language
  if (preferredLanguageInCookie) {
    return preferredLanguageInCookie
  }

  const response = await fetcher.get(
    `${apiUrl}/customer_profile/api/v1/language_management/preferred_language`
  )

  const preferredLanguage = response.data.data.preferredLanguage
  cookies.set(preferredLanguageCookieName, preferredLanguage)
  return preferredLanguage
}

async function getLocation(): Promise<[number, number] | null> {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => resolve([coords.latitude, coords.longitude]),
      () => resolve(null)
    )
  })
}

export const fetchSupportedLanguages = async (): Promise<LanguagesArray> => {
  const { apiUrl } = getConfig()

  const location = await getLocation()

  const url = location
    ? `${apiUrl}/customer_profile/api/v1/language_management/supported_languages?latitude=${location[0]}&longitude=${location[1]}`
    : `${apiUrl}/customer_profile/api/v1/language_management/supported_languages`

  const response = await fetcher.get(url)
  return response.data.data.languages
}
